module.exports = __webpack_public_path__ + "static/media/close-icon.5b9a3ae1.svg";